import { __decorate, __metadata, __param } from "tslib";
import { Inject, Injectable } from 'angular-ts-decorators';
var SectionHelperService = (function () {
    function SectionHelperService($q, $timeout, itemScroller, hashSeeker, sectionSettings) {
        this.$q = $q;
        this.$timeout = $timeout;
        this.itemScroller = itemScroller;
        this.hashSeeker = hashSeeker;
        this.sectionSettings = sectionSettings;
        this.intialize();
    }
    SectionHelperService.prototype.addToScrollQueue = function (sectionId, promise) {
        if (promise === void 0) { promise = null; }
        var deferred = this.$q.defer();
        this.pageSections.push({
            deferred: deferred,
            id: sectionId,
            promise: promise,
        });
        this.onSectionAdded();
        return deferred;
    };
    SectionHelperService.prototype.onSectionAdded = function () {
        this.$timeout.cancel(this.timeout);
        this.timeout = this.$timeout(this.openAndScrollToSection.bind(this));
    };
    SectionHelperService.prototype.intialize = function () {
        this.pageSections = [];
        this.sectionInnerItems = this.hashSeeker.items();
    };
    SectionHelperService.prototype.openAndScrollToSection = function () {
        var _this = this;
        var section = this.hashSeeker.section();
        var preopenedSection = section || this.sectionSettings.sectionExpandedByDefault;
        var pageSection = this.pageSections.filter(function (s) { return s.id === preopenedSection; })[0];
        if (!pageSection) {
            return;
        }
        if (pageSection.promise === null) {
            pageSection.deferred.resolve();
        }
        else {
            pageSection.promise.then(function () {
                pageSection.deferred.resolve();
            });
        }
        if (!section) {
            return;
        }
        this.$q
            .all(this.getAllPromises())
            .then(function () {
            pageSection
                .deferred
                .promise
                .then(function () {
                _this.$timeout(function () {
                    if ('scrollRestoration' in history) {
                        history.scrollRestoration = 'manual';
                    }
                    if (_this.sectionInnerItems.length === 0) {
                        _this.itemScroller.scrollToSection(pageSection.id);
                    }
                    else {
                        _this.itemScroller.scrollToItem(_this.sectionInnerItems);
                    }
                });
            });
        }, function () {
            console.log('REJECTED!');
        });
    };
    SectionHelperService.prototype.getAllPromises = function () {
        return this.pageSections
            .filter(function (s) { return s.promise !== null; })
            .map(function (s) { return s.promise; });
    };
    SectionHelperService.$inject = ['$q', '$timeout', 'itemScroller', 'hashSeeker', 'sectionSettings'];
    SectionHelperService = __decorate([
        Injectable('sectionHelper'),
        __param(0, Inject('$q')),
        __param(1, Inject('$timeout')),
        __param(2, Inject('itemScroller')),
        __param(3, Inject('hashSeeker')),
        __param(4, Inject('sectionSettings')),
        __metadata("design:paramtypes", [Function, Function, Object, Object, Object])
    ], SectionHelperService);
    return SectionHelperService;
}());
export { SectionHelperService };
